// extracted by mini-css-extract-plugin
module.exports = {"video_container":"_31K6S"};